import React from 'react';
import styled from 'styled-components';
import { vars } from '../../../theme';
import HBText from '../../HBText/HBText';
import HBClickable from '../../HBClickable/HBClickable';

interface ITagProps {
    className?: string;
    tag: { _id: string; tag_name: string; color?: string };
    testIdName?: string;
}

/**
 * This was copied from honeybook-react common/tags/tag. DO NOT import and use it outside of this scope
 */
const FilterTag = ({ className, tag, testIdName }: ITagProps) => (
    <StyledDiv
        className={className}
        $color={tag.color}
        testIdName={testIdName}
        title={tag.tag_name}
    >
        <StyledText type="body14" color="text.primary" ellipsis>
            {tag.tag_name}
        </StyledText>
    </StyledDiv>
);

export default FilterTag;

// -------------------------------- Styles -------------------------------- //
const StyledDiv = styled(HBClickable)<{
    $color: string;
}>`
    position: relative;
    padding: ${props => (!!props.$color ? '4px 6px' : '0')};
    height: 26px;
    display: inline-flex;
    width: fit-content;
    overflow: hidden;
    border-radius: ${vars.radius.xs};
    gap: 3px;
    align-items: center;
    background-color: ${props => props.$color};
`;

const StyledText = styled(HBText)`
    overflow-wrap: break-word;
`;
